import { BaseResource } from "./BaseResource";
import { apiResourceUrl } from "@ploy-lib/core";
class UnrecognizedEmailResource extends BaseResource {
    pk() {
        return this.id?.toString();
    }
}
UnrecognizedEmailResource.urlRoot = apiResourceUrl("unrecognized-email/{id}");
export { UnrecognizedEmailResource };
//# sourceMappingURL=UnrecognizedEmailResource.js.map